import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";

export const CinematicBackground: React.FC = () => {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();

  // Create 15 floatable particles
  const particles = Array.from({ length: 15 }).map((_, i) => {
    const seed = i * 123.45;
    const initialX = Math.abs(Math.sin(seed)) * width;
    const initialY = Math.abs(Math.cos(seed)) * height;
    
    // Float path based on frame
    const deltaX = Math.sin(frame * 0.005 + seed) * 80;
    const deltaY = -frame * 0.4 - Math.cos(frame * 0.004 + seed) * 40; // float upwards
    
    const x = (initialX + deltaX + width) % width;
    const y = (initialY + deltaY + height) % height;
    
    const size = 6 + Math.abs(Math.sin(frame * 0.01 + seed)) * 12;
    const opacity = 0.15 + Math.abs(Math.cos(frame * 0.008 + seed)) * 0.45;

    return (
      <div
        key={i}
        style={{
          position: "absolute",
          left: x,
          top: y,
          width: size,
          height: size,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(255,140,0,0.8) 0%, rgba(255,140,0,0) 70%)",
          filter: "blur(2px)",
          opacity,
          transform: "translate(-50%, -50%)",
        }}
      />
    );
  });

  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "100%",
        background: "radial-gradient(circle at center, #101015 0%, #050508 100%)",
        overflow: "hidden",
      }}
    >
      {/* Cinematic grid lines overlay */}
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: "radial-gradient(rgba(255,140,0,0.02) 1px, transparent 1px)",
          backgroundSize: "24px 24px",
          opacity: 0.8,
        }}
      />
      {particles}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
